<template>
  <div class="position-relative" :class="{ isBoxOpen: isOpen ,isFolder:tree.folder}">
    <div
      class="item"
      :class="{
        Custom0: tree.Class.match('custom0'),
        Custom1: tree.Class.match('custom1'),
        Custom2: tree.Class.match('custom2'),
        Custom3: tree.Class.match('custom3'),
        bold: tree.folder,
        overWaku: mouseOver && getClickMember!=tree.Member,
        ClickWaku: getClickMember == tree.Member ? true:false,
        isOpen: isOpen,
      }"
      v-on:Click="onClick"
      :id="tree.Member"
      v-on:mouseover="mouseOverAction"
      v-on:mouseleave="mouseOverAction"
    >
      {{ tree.title }}
    </div>
    <button v-on:Click="showStatus" class="tree_detail"><span class="only_pc">詳細を表示</span><span class="only_sp">＋</span></button>
    <!-- ポップアップ表示用 -->
    <div :id="'info'+tree.Member" class="info">
      <table>
        <tr>
          <th>会員番号:</th>
          <td>{{ tree.Member }}</td>
        </tr>
        <tr>
          <th>会員ランク:</th>
          <td>{{ tree.Rank }}</td>
        </tr>
        <tr>
          <th>氏名:</th>
          <td class="treeitem_name">{{ tree.Name }}</td>
        </tr>
        <tr v-if="isManagerJ">
          <th>誕生日:</th>
          <td>{{ viewBirth() }}</td>
        </tr>
        <tr>
          <th>段数:</th>
          <td>{{ tree.Nest }}</td>
        </tr>
        <tr>
          <th>自己購入実績数:</th>
          <td>{{ tree.BuyCount }}</td>
        </tr>
        <tr>
          <th>自己購入累計実績数:</th>
          <td>{{ tree.SumBuyed }}</td>
        </tr>
        <tr>
          <th>G人数:</th>
          <td>{{ tree.AllGroup }}</td>
        </tr>
        <tr>
          <th>G実績数:</th>
          <td>{{ tree.AllBuyed }}</td>
        </tr>
        <tr>
          <th>使用可能ポイント:</th>
          <td>{{ tree.Point }}</td>
        </tr>
      </table>
      <p class="limit_text">(内3/31で失効となるポイント:{{tree.Point2}})</p>
    </div>
    <!-- ポップアップ表示用 -->
    <ul v-if="tree.folder" v-show="isOpen">
      <li v-for="item in tree.children" :key="item.Name">
        <treeItem
          :tree="item"
          :fullOpen="fullOpen"
        ></treeItem>
      </li>
    </ul>
  </div>
</template>
<script>
import treeItem from "./treeItem";
import Swal from "sweetalert2";
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  name: "treeItem",
  components: {
    treeItem,
  },
  props: ["tree", "fullOpen"],
  data() {
    return {
      nowClick: false,
      isOpen: false,
      mouseOver: false,
      childList: [],
      clickMember:"",
      isManagerJ:false,
    };
  },
  mounted() {

    if (this.tree.Nest == 0) {
      this.isOpen = true;
    } else if (this.tree.Rank == "V") {
      this.isOpen = false;
    } else {
      this.isOpen = true;
    }

    console.log("tree debug ", this.tree);
    
    this.isManagerJ = auth.isManager_J();
  },
  watch: {
    /*fullOpen: function () {
      this.isOpen = true;
    },*/
  },
  computed:{
    getClickMember(){
      return this.$store.state.treeIsClickMember;
    }
  },
  methods: {
    onClick() {
      this.$store.state.treeIsClickMember=this.tree.Member;
      this.Open();
    },
    Open() {
      if (this.tree.folder) {
        this.isOpen ? (this.isOpen = false) : (this.isOpen = true);
      }
    },
    mouseOverAction() {
      this.mouseOver ? (this.mouseOver = false) : (this.mouseOver = true);
    },
    showStatus() {
        let mes = document.getElementById('info'+this.tree.Member).innerHTML;
      Swal.mixin({
        confirmButtonText: "閉じる",
        reverseButtons: true,
      }).fire({
        title: "会員情報",
        html: mes,
        allowOutsideClick: false,
      });
    },
    viewBirth(){
      var date = new Date(this.tree.Birthday);
      return (date.getMonth()+1)+'/'+date.getDate();
    },
  },
};
</script>
<style scoped>
.info {
  display: none;
}
th {
  text-align: right !important;
}
td {
  text-align: left !important;
  font-weight: bold !important;
}
td.treeitem_name {
  max-width: 90px;
}
.limit_text {
  font-size: 15px;
  color: #545454;
  font-weight: 300
}
#mes {
  margin-left: auto !important;
  margin-right: auto !important;
}
input {
  border: none;
}
.ClickWaku {
  outline: 0;
}
body {
  font-family: Menlo, Consolas, monospace;
  color: #444;
}
.Custom0 {
  background: white;
}
.Custom1 {
  background: yellow;
}
.Custom2 {
  background: orange;
}
.Custom3 {
  background: #50c550;
}
.item {
  cursor: pointer;
}
.tree_detail {
  position: absolute;
  top: 13px;
  right: 10px;
  padding: 2px 5px;
  font-size: 1.2rem;
}
.bold {
  font-weight: bold;
}
.overWaku {
  border: 2px solid rgb(160, 236, 255); /* 枠線 */
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
}
div#tree ul li {
    padding-left: 25px;
    position: relative;
}
div#tree ul li:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 0;
    height: 100%;
    border-left: 1px dashed #bbb;
}
div#tree ul li:before {
    position: absolute;
    content: "";
    display: block;
    border-top: 1px dashed #bbb;
    top: 26px;
    left: 0;
    width: 13px;
    height: 0;
}
div#tree ul li:last-child:after {
    height: 26px;
}
div#tree > ul > li:before, div#tree > ul > li:after {
    border: none;
}
div.item {
    line-height: 40px;
    padding: 5px 0;
    margin-bottom: 5px;
}
.isFolder > .item:before {
    content: "";
    border: 2px solid;
    width: 5px;
    height: 5px;
    display: inline-block;
    border-color: #424242 #424242 transparent transparent;
    transform: rotate(45deg);
    margin: 0 8px 2px;
}
.isBoxOpen.isFolder > .item:before {
  border-color: transparent #424242 #424242 transparent;
  margin: 0 8px 5px;
}
.isFolder .item {
    font-weight: 300;
}
.swal2-header {
    background: #ccc !important;
    margin-bottom: 10px !important;
}
.swal2-content th, .swal2-content td {
    font-weight: 300 !important;
    font-size: 18px !important;
    line-height: 35px !important;
}
.overWaku {
    border: none !important;
}
button.swal2-confirm.swal2-styled {
    font-size: 18px !important;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .tree_detail {
    top: 3px;
  }
  div.item {
    font-size: 14px;
    line-height: 30px;
    padding: 0px;
    margin-right: 35px;
    margin-bottom: 0px;
    word-break: break-all;
  }
  div#tree ul {
    margin-left: 10px;
  }
  div#tree ul li {
    padding-left: 10px;
  }
div#tree ul li:before {
    top: 15px;
  }
  div#tree ul li:last-child:after {
      height: 15px;
  }
}

</style>